import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit, FaEye } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import FtpConfigModalContent from "./ModalContent/FtpConfigModalContent";
import { useFTPConfigList } from "./hook/useFTPImportBatches";

const FtpConfigure = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null); // 👈 store selected row
  const [loadingModal, setLoadingModal] = useState(false);   // 👈 modal loading spinner
const [show,setShow]=useState(false)
const [mode,setMode]=useState<any>('')
  const [filtersState, setFiltersState] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
  });

  const { data: ftpconfig,isLoading:isLoading } = useFTPConfigList({
    params: {
      page: filtersState.page,
      limit: filtersState.limit,
      search: filtersState.search,
    },
    enable: true,
  });

  const toggleModal = () =>{ 
    setMode('add')
    setIsModalOpen(!isModalOpen);
  };
  const handleClose = () => setIsModalOpen(false);

  const handlePagination = (pageNo: number) => {
    setFiltersState((prev: any) => ({ ...prev, page: pageNo }));
  };

  const handleSearch = (val: any) => {
    setFiltersState((prev: any) => ({ ...prev, search: val }));
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prev: any) => ({ ...prev, page: pageNo, limit }));
  };

  // 👇 columns defined here so we can access `setSelectedRow`
  const ftpConfigDataColumns = [
    {
      name: "Host",
      selector: (row: { Host: string }) => row.Host,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Username",
      selector: (row: { Username: string }) => row.Username,
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Password",
      selector: (row: { Password: string }) => row.Password,
      sortable: false,
      minWidth: "180px",
      cell: (row: any) => {
      return( <div className="d-flex align-items-center gap-2">
      <span style={{ fontFamily: "monospace" }}>
        {show ? row.Password : "•".repeat(row.Password.length)}
      </span>
      <button
        type="button"
        onClick={() => setShow(!show)}   // ❌ setShow is not defined
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer",
          padding: 0,
        }}
      >
        <FaEye size={16} />
      </button>
    </div>
      )
    },
    },
    {
      name: "Port",
      selector: (row: { Port: string }) => row.Port,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Action",
      width: "150px",
      cell: (row: any) => (
        <button
          onClick={() => {
            setIsModalOpen(true);   // open modal
            setSelectedRow(row);  // load row data
             setMode('edit')
          }}
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];

  return (
    <div className="p-4">
      <PageHeader
        title="FTP Config"
        buttons={[
          { label: "+ Add FTP Config", onClick: toggleModal, color: "#2e8dd3" },
        ]}
      />

      <BasicDataTable
      dynamicHeightOnRowsPerPage={true}
        Title="FTP Config"
        data={ftpconfig?.data?.FTPConfigs}
        showSpinner={isLoading}
        columns={ftpConfigDataColumns}
        paginationTotalRows={ftpconfig?.data?.Pagination?.TotalCount}
        onChangePage={handlePagination}
        onChangeRowsPerPage={handleonChangeRowsPerPage}
        handleSearch={handleSearch}
      />

      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={mode!=='add' ? "Edit Config" : "Add Config"}
        size="md"
        content={ 
            <FtpConfigModalContent
              handleClose={handleClose}
              // handleSubmit={selectedRow} // 👈 pass selected data to modal
            mode={mode}
            selectedRow={selectedRow}
            />
          
        }
      />
    </div>
  );
};

export default FtpConfigure;
